<template>
	<AppLayout :title="trans('menu.association.assemblies')">
		<template #actions>
			<PrimaryButton v-if="canVote" :color="Color.Green" @click.stop="vote">
				<i class="fa-solid fa-check mr-2"/>
				{{ trans('admin.audit.elections.admissions.vote.title') }}
			</PrimaryButton>
		</template>
		<CardGrid>
			<Card v-for="assembly in assemblies" :key="`candidate-${assembly.id}`" :title="assembly.title">
				<template #footer>
					<Link :as="SecondaryButton" :color="Color.Blue" :href="route('association.assemblies.show', assembly.id)">
						<i class="fa-solid fa-eye mr-2"/>
						{{ trans('general.view') }}
					</Link>
				</template>
			</Card>
		</CardGrid>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import Card from '@/Components/Cards/Card.vue'
import {defineProps, type Ref, ref} from 'vue'
import AppLayout from '@/Layouts/AppLayout.vue'
import CardGrid from '@/Components/Cards/CardGrid.vue'
import PrimaryButton from '@/Components/Buttons/PrimaryButton.vue'
import {type Assembly} from '@/Types/Association/Assemblies/Assembly'
import SecondaryButton from '@/Components/Buttons/SecondaryButton.vue'

const props = defineProps<{
	assemblies:Array<Assembly>,
}>()

const assemblies:Ref<Array<Assembly>> = ref(props.assemblies)
</script>